// extracted by mini-css-extract-plugin
export default {"customButtonContainer":"CustomButton_customButtonContainer__Qf66M"};